export class TimeExpenseEmailSubmissionSaveNoteParameterDto {
    entryId: number;
    newNote: string;
    submissionId: string;
    userId: string;
}
